import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { getStatusColor } from '../utils'
import { getOrderStatusIcon } from '@/config/design-tokens'
import type { CancelStatus } from '../types'

interface OrderStatusBadgeProps {
  status: string
  cancelStatus?: CancelStatus
  className?: string
}

export function OrderStatusBadge({ status, cancelStatus, className }: OrderStatusBadgeProps) {
  const { t } = useTranslation('orders')
  const colors = getStatusColor(status, cancelStatus)
  const isCancelled = cancelStatus === 'cancelled'

  const displayStatus = isCancelled ? 'cancelled' : status.toLowerCase()
  const label = t(`status.${displayStatus}`, status)
  const Icon = getOrderStatusIcon(displayStatus, isCancelled)

  return (
    <Badge
      variant="outline"
      className={cn(
        colors.bg,
        colors.text,
        colors.border,
        'font-medium gap-1',
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  )
}
